<template>
	<div class="tab">
		<div
			class="tab__header"
			:class="[
				{ 'tab__header--completed': completed },
				{ 'tab__header--active': active }
			]"
			@click="$emit('changedTab', id)"
		>
			{{ title }}
		</div>
		<div
			class="tab__body"
			v-show="active"
		>
			<slot></slot>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/tab';
</style>

<script>
export default {
	name: 'Tab',
	props: {
		id: {
			Number
		},
		title: {
			type: String,
		},
		completed: {
			type: Boolean,
		},
		active: {
			type: Boolean,
		},
	},
}
</script>